/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import { SimTypography } from 'components/SimTypography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { SimButton } from 'components/SimButton';
import { useTheme } from '@mui/material/styles';

const validationSchema = yup.object({
	firstName: yup
		.string()
		.trim()
		.min(2, 'Please enter a valid name')
		.max(50, 'Please enter a valid name')
		.required('Please specify your first name'),
	lastName: yup
		.string()
		.trim()
		.min(2, 'Please enter a valid name')
		.max(50, 'Please enter a valid name')
		.required('Please specify your last name'),
	email: yup.string().trim().email('Please enter a valid email address').required('Email is required.'),
	message: yup.string().trim().required('Please specify your message')
});

const QuickQueryForm = () => {
	const theme = useTheme();

	const initialValues = {
		firstName: '',
		lastName: '',
		email: '',
		message: ''
	};

	const onSubmit = values => {
		return values;
	};

	const formik = useFormik({
		initialValues,
		validationSchema: validationSchema,
		onSubmit
	});

	return (
		<Box maxWidth={600} margin={'0 auto'}>
			{/* START - SECTION-TITLE HEADER */}
			<Box marginBottom={4}>
				<SimTypography
					variant='h4'
					align={'center'}
					data-aos={'fade-up'}
					gutterBottom
					sx={{
						fontWeight: 700
					}}>
					Not sure if you're ready to start?
				</SimTypography>
				<SimTypography variant='h6' align={'center'} color={'text.secondary'} data-aos={'fade-up'}>
					Write to us anyway
				</SimTypography>
			</Box>
			{/* END START - SECTION-TITLE HEADER */}

			<Box>
				<form onSubmit={formik.handleSubmit}>
					<Grid container spacing={4}>
						<Grid item xs={12} sm={6}>
							<TextField
								sx={{ height: 54 }}
								label='First name'
								variant='outlined'
								color='primary'
								size='medium'
								name='firstName'
								fullWidth
								value={formik.values.firstName}
								onChange={formik.handleChange}
								error={formik.touched.firstName && Boolean(formik.errors.firstName)}
								helperText={formik.touched.firstName && formik.errors.firstName}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								sx={{ height: 54 }}
								label='Last name'
								variant='outlined'
								color='primary'
								size='medium'
								name='lastName'
								fullWidth
								value={formik.values.lastName}
								onChange={formik.handleChange}
								error={formik.touched.lastName && Boolean(formik.errors.lastName)}
								helperText={formik.touched.lastName && formik.errors.lastName}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								sx={{ height: 54 }}
								label='Email'
								type='email'
								variant='outlined'
								color='primary'
								size='medium'
								name='email'
								fullWidth
								value={formik.values.email}
								onChange={formik.handleChange}
								error={formik.touched.email && Boolean(formik.errors.email)}
								helperText={formik.touched.email && formik.errors.email}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								label='Message'
								multiline
								rows={6}
								variant='outlined'
								color='primary'
								size='medium'
								name='message'
								fullWidth
								value={formik.values.message}
								onChange={formik.handleChange}
								error={formik.touched.message && Boolean(formik.errors.message)}
								helperText={formik.touched.message && formik.errors.message}
							/>
						</Grid>
						<Grid item container justifyContent={'center'} xs={12}>
							<SimButton
								sx={{ height: 54, minWidth: 150 }}
								variant='contained'
								color='primary'
								size='medium'
								type='submit'>
								Submit
							</SimButton>
						</Grid>
						<Grid item container justifyContent={'center'} xs={12}>
							<SimTypography color='text.secondary'>
								We'll get back to you in 1-2 business days.
							</SimTypography>
						</Grid>
						<Grid item xs={12}>
							<Divider />
						</Grid>
						<Grid item container justifyContent={'center'} xs={12}>
							<Box>
								<SimTypography component='p' variant='body2' align='left'>
									By clicking on "submit" you agree to our{' '}
									<Box component='a' href='' color={theme.palette.text.primary} fontWeight={'700'}>
										Privacy Policy
									</Box>
									,{' '}
									<Box component='a' href='' color={theme.palette.text.primary} fontWeight={'700'}>
										Data Policy
									</Box>{' '}
									and{' '}
									<Box component='a' href='' color={theme.palette.text.primary} fontWeight={'700'}>
										Cookie Policy
									</Box>
									.
								</SimTypography>
							</Box>
						</Grid>
					</Grid>
				</form>
			</Box>
		</Box>
	);
};

export { QuickQueryForm };
